import zhCN from './zh-CN'
import en from './en'
export default{
    'zh-CN': zhCN,
    'en': en
}



// WEBPACK FOOTER //
// ./src/locales/index.js